import React, { Component } from 'react'

export default class RightSideBar extends Component {
    render() {
        return (
            <div className="RightSideBar">
              RightSideBar  TODO
            </div>
        )
    }
}
